import React, { useState, useEffect } from "react";
import { getLocales } from "../../api/splashscreen";
import { setLocale } from "../../store/actions/authActions";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Select from "react-select";
import "./style.scss";
import "/node_modules/flag-icons/css/flag-icons.min.css";

const FixedLangSwitcher = React.memo((props) => {
    const [currentLanguage, setcurrentLanguage] = useState({
        locale: "es_ES",
        rtl: false,
        name: "Español (España)",
        region: "ES"
    });
    const [languages, setlanguages] = useState([]);

    const getCurrentLanguage = React.useCallback(
        (langs) => {
            // On cherche le language + pays exact
            let currentLanguage = langs.find(
                (language) => language.locale === props.i18n.language.replace(/-/g, "_")
            );

            // Si on n'a pas trouvé le langage + pays exact, on cherche le langage tout court
            if (!currentLanguage) {
                currentLanguage = langs.find(
                    (language) => language.locale === props.i18n.language.substring(0, 2)
                );
            }

            if (!currentLanguage) {
                currentLanguage = langs[0];
            }

            setcurrentLanguage(currentLanguage);
        },
        [props.i18n.language, setcurrentLanguage]
    );

    const _getLocales = React.useCallback(() => {
        getLocales()
            .then((data) => {
                getCurrentLanguage(data);
                setlanguages(data);
            })
            .catch((err) => console.log(err));
    }, [getCurrentLanguage, setlanguages]);

    useEffect(() => {
        _getLocales();
    }, [_getLocales]);

    useEffect(() => {
        if (languages !== []) {
            getCurrentLanguage(languages);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.i18n.language]);

    const changeLocale = (locale) => {
        props.setLocale(locale.replace(/_/g, "-"));
        props.i18n.changeLanguage(locale.replace(/_/g, "-")); // locale.locale is the code "fr_FR", while locale is an object
        _getLocales();
    };

    const onSelectChange = (option) => {
        changeLocale(option.value);
    };

    const options = () => {
        const table = [];
        languages.forEach((lang) => {
            table.push({
                value: lang.locale,
                label: (
                    <div className="ls-row">
                        <span className={`flag`}><span className={`fi fi-${lang?.region.toLowerCase()} `}></span></span>
                        {lang.name}
                    </div>
                ),
            });
        });

        return table;
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: "white",
            color: "black",
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "transparent",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "white",
        }),
    };

    return (
        <div className="select-wrapper">
            <Select
                isSearchable={false}
                classNamePrefix="lang-switcher"
                menuPlacement="top"
                styles={customStyles}
                className="lang-switcher"
                value={{
                    value: currentLanguage?.locale,
                    label: (
                        <div className="ls-row">
                            <span className={`flag`}><span className={`fi fi-${currentLanguage?.region.toLowerCase()} `}></span></span>
                            {currentLanguage?.name}
                        </div>
                    ),
                }}
                onChange={onSelectChange}
                options={options()}
            />
        </div>
    );
});

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        setLocale: (locale) => {
            dispatch(setLocale(locale));
        },
    };
};

export default withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(FixedLangSwitcher)
);
